import { render, staticRenderFns } from "./FileDrop.vue?vue&type=template&id=15b79c8e&scoped=true"
import script from "./FileDrop.vue?vue&type=script&lang=js"
export * from "./FileDrop.vue?vue&type=script&lang=js"
import style0 from "./FileDrop.vue?vue&type=style&index=0&id=15b79c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b79c8e",
  null
  
)

export default component.exports